// Works
export const works = [
  {
    title: "Sublima Lashes",
    subtitle: "E-commerce",
    category: "Wordpress Development",
    tags: ["Wireframes", "Templates", "CSS3", "UI/UX", "WPO", "Landing Page"],
    cover: "./img/projects/sublima--3.webp",
    link: "https://www.sublimalashes.com/",
    class: "full wide",
  },
  {
    title: "Delaviuda",
    subtitle: "E-commerce",
    category: "Wordpress Development",
    tags: ["Templates", "CSS3", "ACF", "WooCommerce", "SEO", "WPO"],
    cover: "./img/projects/delaviuda.webp",
    link: "https://www.delaviuda.com/",
    class: "square half",
  },
  {
    title: "El Almendro",
    subtitle: "E-commerce",
    category: "Wordpress Development",
    tags: ["Templates", "CSS3", "ACF", "WooCommerce", "SEO", "WPO"],
    cover: "./img/projects/elalmendro.webp",
    link: "https://www.elalmendro.com/",
    class: "square half",
  },
  {
    title: "PSworks",
    subtitle: "Agency",
    category: "Wordpress Development",
    tags: ["JS", "CSS3", "ACF", "CPT UI", "SEO", "WPO"],
    cover: "./img/projects/psworks_02.webp",
    link: "https://www.psworks.es/",
    class: "full wide",
  },
  {
    title: "Socialisssima",
    subtitle: "Agency",
    category: "Wordpress Design & Development",
    tags: ["JS", "CSS3", "ACF", "CPT UI", "SEO", "WPO"],
    cover: "./img/projects/socialisssima_2024.webp",
    link: "https://socialisssima.com/",
    class: "full wide",
  },
  {
    title: "Pollinators & Prairies",
    subtitle: "Institution",
    category: "Wordpress Development",
    tags: ["UX", "UI", "PHP", "CSS3", "SEO", "WPO"],
    cover: "./img/projects/pp_texas.webp",
    link: "https://pollinatorsandprairies.org/",
    class: "square half",
    blog_link:
      "https://juanfalibene.com/writing/#/post/id=1369&category=trabajo-cotidiano",
  },
  {
    title: "Amazon FE",
    subtitle: "Consulting",
    category: "Wordpress UX / UI",
    tags: ["UI", "UX", "Heuristic Analysis"],
    cover: "./img/projects/amazon_fe.webp",
    link: "https://www.amazonfutureengineer.com/",
    blog_link: "https://juanfalibene.com/writing/#/case-study/109",
    class: "square half",
  },
  {
    title: "Irene Pietrella",
    subtitle: "Portfolio",
    category: "Wordpress Development",
    tags: ["PHP", "JS", "CSS3", "ACF", "Templates", "SEO", "WPO"],
    cover: "./img/projects/irene-pietrella.webp",
    link: "https://irene-pietrella.com/",
    /*blog_link: "https://juanfalibene.com/writing/#/case-study/84",*/
    class: "vertical quarter",
  },
  {
    title: "Martina Orska",
    subtitle: "Portfolio",
    category: "Wordpress Development",
    tags: ["PHP", "ACF", "CPT UI", "JS", "CSS3", "SEO", "WPO"],
    cover: "./img/projects/martina_orska.webp",
    link: "https://martinaorska.com/",
    /*blog_link: "https://juanfalibene.com/writing/#/case-study/831",*/
    class: "vertical quarter",
  },
  {
    title: "Rocio Ley",
    subtitle: "Portfolio",
    category: "Wordpress Development",
    tags: ["ACF", "JS", "CSS3", "CPT UI", "SEO", "WPO"],
    cover: "./img/projects/03_smoda.webp",
    link: "https://rocioley.com",
    class: "vertical quarter",
    /*blog_link: "https://juanfalibene.com/writing/#/case-study/11",*/
  },
];
// Projects
export const projects = [
  {
    title: "Discava!",
    subtitle: "Vinyl Search APP",
    category: "Front End Development",
    tags: [
      "HTML5",
      "CSS3",
      "JS Vanilla",
      "Discogs API",
      "Youtube Playlist",
      "Local Storage",
    ],
    cover: "./img/projects/discava-v2.webp",
    link: "http://dev.juanfalibene.com/discava/index.html",
    github_link: "https://github.com/juanfalibene/discava-digital",
    blog_link:
      "https://juanfalibene.com/writing/#/post/id=1943&category=idea-de-proyecto",
    class: "full wide",
  },
  {
    title: "CaliTrack",
    subtitle: "AI App",
    category: "AI vibe coding",
    tags: ["React.js", "CSS3", "JS Vanilla", "HTML5"],
    cover: "./img/projects/calitrack_mobile.webp",
    link: "https://jf-calitrack.lovable.app/",
    blog_link:
      "https://juanfalibene.com/writing/#/post/id=1909&category=idea-de-proyecto",
    class: "half square",
  },
  {
    title: "Juan Falibene Writing",
    subtitle: "WP Headless",
    category: "Wordpress & Front End Development",
    tags: [
      "WP REST API",
      "JWT Auth",
      "ACF",
      "CPT UI",
      "React.js",
      "CSS3",
      "HTML5",
      "SEO",
    ],
    cover: "./img/projects/project_blog_writing.webp",
    link: "https://juanfalibene.com/writing",
    class: "half square",
    blog_link:
      "https://juanfalibene.com/writing/#/post/id=28&category=idea-de-proyecto",
  },
  {
    title: "Daily News",
    subtitle: "React Web APP",
    category: "Front End Development",
    tags: [
      "React",
      "Redux",
      "Google API",
      "G News API",
      "Axios",
      "Material UI",
    ],
    cover: "./img/projects/daily-news-app-g.webp",
    link: "https://dev.juanfalibene.com/daily-news",
    github_link: "https://github.com/juanfalibene/daily-news",
    class: "half wide",
  },
  {
    title: "Dev Tree",
    subtitle: "WP Theme",
    category: "Wordpress Development",
    tags: [
      "PHP",
      "CMS",
      "ACF",
      "CPT UI",
      "Templates",
      "CSS3",
      "HTML5",
      "JS Vanilla",
      "Antigravity",
      "AI",
      "GitHub Actions",
      "Python",
    ],
    cover: "./img/projects/project-wp-theme-dev.webp",
    link: "https://links.juanfalibene.com/dev-tree/",
    class: "half square",
    github_link: "https://github.com/juanfalibene/web-dev-tree",
    blog_link:
      "https://juanfalibene.com/writing/#/post/id=235&category=idea-de-proyecto",
  },
  {
    title: "Music Portfolio",
    subtitle: "Navigation",
    category: "Front End Development",
    tags: ["React", "React Router", "React Hooks"],
    cover: "./img/projects/project02.webp",
    link: "https://music.juanfalibene.com/",
    github_link: "https://github.com/juanfalibene/react-music-portfolio",
    class: "half square",
  },
  {
    title: "Simple Projects",
    subtitle: "Collection",
    category: "Front End Development",
    tags: ["JS Vanilla", "React", "CSS3", "HTML5"],
    cover: "./img/projects/song_of_the_day_app.webp",
    link: "https://juanfalibene.com/writing/#/challenges",
    github_link: "https://github.com/juanfalibene/",
    class: "half square",
  },
];
// Clients
export const clients = [
  {
    name: "Pablo Martinez Herrera",
    link: "https://www.linkedin.com/in/pablo-mart%C3%ADnez-herrera-93529345/",
    since: 2019,
  },
  {
    name: "Socialisssima",
    link: "https://socialisssima.com",
    since: 2020,
  },
  {
    name: "PS Works",
    link: "https://psworks.es",
    since: 2022,
  },
  {
    name: "Partida Continua",
    link: "https://partidacontinua.com/",
    since: 2023,
  },
];

export const hard_skills = [
  {
    skill: "HTML5",
    image: "./img/skills/html-5.svg",
  },
  {
    skill: "CCS3",
    image: "./img/skills/css-3.svg",
  },
  {
    skill: "JS",
    image: "./img/skills/js.svg",
  },
  {
    skill: "React",
    image: "./img/skills/react.svg",
  },
  {
    skill: "Wordpress",
    image: "./img/skills/wordpress.svg",
  },
  {
    skill: "PHP",
    image: "./img/skills/php_02.svg",
  },
  {
    skill: "Python",
    image: "./img/skills/python.svg",
  },
  {
    skill: "Github",
    image: "./img/skills/github-mark-white.svg",
  },
];

export const soft_skills = [
  {
    skill: "Problem Solving",
  },
  {
    skill: "Creativity",
  },
  {
    skill: "Effective Communication",
  },
  {
    skill: "Detail Orientation",
  },
  {
    skill: "Team Collaboration",
  },
  {
    skill: "Time Management",
  },
];
// About
export const about = [
  {
    name: "Juan Falibene",
    text: "Barcelona, Spain",
    profession: "Web Developer • WordPress & Front-End",
    image: "./img/juanfalibene_profile_hover.jpg",
    imagePic: "./img/juanfalibene_profilepic_06_2025.webp",
    resume_page: "./resume/index.html",
    bio_lead:
      "Full-cycle web development with technical criteria, clean architecture, and reliable execution.",
    bio_story:
      "My journey as a developer has been shaped by a hybrid path of continuous self-directed learning and working side by side with agencies and individual clients. You can read more about my background in my <a href='https://juanfalibene.com/writing/#/post/id=522&category=historia' target='_blank' rel='noopener noreferrer'>story on the blog</a>.",
    bio_excerpt:
      "With over 6 years of experience across design studios, agency workflows, and direct clients, I operate flexibly as a custom developer, white-label tech partner, or technical consultant. My approach bridges design fidelity and clean code, ensuring every platform is fast, secure, and built to scale.",
    bio_values:
      "Technical criteria over quick fixes. Every project comes with its own tech stack and constraints. My focus isn't on pushing a single tool, but on understanding the existing architecture to develop reliable solutions, optimize performance, fix complex issues, and ensure a scalable digital asset.",
    bio: "My <a href='https://juanfalibene.com/writing/#/post/id=522&category=historia' target='_blank' rel='noopener noreferrer'>journey</a> has been shaped by a combination of formal education and self-taught expertise, growing alongside agencies and individual clients. I thrive on collaboration throughout the entire process, ensuring that every project balances creativity, performance, and client-specific goals.",
  },
];
// Sections
export const section_description = [
  {
    section: "Works",
    description:
      "Over the past 6 years, I have specialized in designing and developing WordPress websites for agencies and individual clients. I provide complete solutions, including design, development, support, and knowledge transfer to ensure every project's success.",
  },
  {
    section: "Blog",
    description:
      "I invite you to explore my <a href='https://juanfalibene.com/writing/' target='_blank' rel='noopener noreferrer'>blog</a>, where I share more about my journey and expand on my work. You'll find insights into my latest projects, reflections on web development, and an archive of my work's.",
  },
  {
    section: "Projects",
    description:
      "A curated selection of custom web applications, specialized tools, and interactive digital products engineered with modern web architectures, performance optimization, and clean code.",
  },
];

// Hero Content
export const hero_content = {
  headline: "Web Developer specializing in WordPress & Front-End — custom development, technical consulting, and tech partner for agencies and brands.",
  subtitle: "Helping design agencies, product leads, and businesses build new web platforms, unblock complex technical challenges, and scale digital products with solid engineering fundamentals (HTML, CSS, JS/React, PHP).",
  manifesto: "Technical criteria over quick fixes. Every project comes with its own tech stack and constraints. My focus isn't on pushing a single tool, but on understanding the existing architecture — whether it's a page builder, a custom theme, or a block-based setup — to develop reliable solutions, optimize performance, and ensure a scalable digital asset.",
};

// Services — Intro Headline & Subtitle
export const services_intro = {
  headline: "Specialized web engineering for agencies and brands that demand custom development, technical criteria, and reliable platforms.",
  subtitle: "From custom full-stack development and agency tech partnering to in-depth technical audits, consulting, and proactive maintenance.",
};

// Services List
export const services_list = [
  {
    id: 1,
    title: "Custom Web & WordPress Development",
    description: "Custom frontend and WordPress development built on modern architectures: clean markup (HTML5/CSS3/JS/React), custom theme and plugin engineering, API integrations, and native block development (FSE/Gutenberg). Modular, maintainable code engineered for technical SEO and peak load speed.",
  },
  {
    id: 2,
    title: "Technical WordPress Audit",
    description: "Deep-dive diagnosis of performance, database health, plugin/theme architecture, and security risks, delivered with a prioritized action plan.",
  },
  {
    id: 3,
    title: "Technical Consulting & Architecture",
    description: "Strategic guidance before major builds or migrations. Selection of the right stack (builders vs. native blocks vs. custom code), data architecture, and API/CRM integrations.",
  },
  {
    id: 4,
    title: "Proactive Maintenance & Support",
    description: "Ongoing managed technical support testing updates in Staging environments, with automated backups, monitoring, and rollback protocols.",
  },
  {
    id: 5,
    title: "Performance & Speed Optimization (WPO)",
    description: "Root-cause optimization targeting Core Web Vitals (LCP, CLS, INP) through code cleanup, database query tuning, and proper caching strategies.",
  },
  {
    id: 6,
    title: "Troubleshooting & Issue Resolution",
    description: "Focused technical intervention to isolate and fix critical breakages, plugin conflicts, post-update errors, or security/malware issues.",
  },
  {
    id: 7,
    title: "Launch Support & Deployment",
    description: "Controlled production rollouts including pre-launch checklists, SEO 301 redirect mapping, stress testing, and post-launch monitoring.",
  },
];

// Client Fit
export const client_fit = {
  bestFit: [
    "Design & marketing agencies seeking a senior technical partner to handle development, support, or troubleshooting for their clients reliably.",
    "Businesses with live sites (whether built with page builders, custom themes, or native blocks) facing performance bottlenecks, update breakages, or technical limits.",
    "Teams needing custom PHP/JS features or seamless API/CRM integrations.",
    "Projects requiring strategic technical guidance prior to a redesign or platform migration.",
  ],
  notFit: [
    "Clients looking for superficial, quick-fix patches without addressing the root cause of the issue.",
    "Collaborations where technical input is not valued or where there is no openness to improve the project together across all fronts. Scale is never a barrier: I get fully involved in both small and large projects that make strategic sense or spark genuine motivation, as long as we prioritize clear, honest, and transparent communication above all else.",
  ],
};

// FAQs
export const faqs = [
  {
    question: "How do you integrate AI into your workflow, and why is technical criteria still essential?",
    answer: "AI is an active part of our present and a key accelerator in my daily workflow — this very portfolio and many of my projects leverage AI-assisted tools and coding workflows. However, generating code or building pages quickly does not automatically produce a secure, performant, and scalable platform. AI amplifies speed and creativity, but web engineering fundamentals, deep diagnostics, solid architecture, and production accountability remain indispensable to avoid technical debt and guarantee long-term reliability.",
  },
  {
    question: "How do you prevent plugin accumulation and quick fixes from causing technical debt or update breakages?",
    answer: "Accumulated quick fixes and unvetted plugins are the primary cause of site instability and slow speeds. I diagnose the root causes, replace bloated third-party dependencies with clean, native code, and test all updates in isolated Staging environments with automated rollbacks.",
  },
  {
    question: "How do you collaborate with design agencies and team workflows?",
    answer: "I operate as a technical partner or white-label developer. I can integrate seamlessly into your tools (Slack, Figma, GitHub, Notion) respecting timelines, code quality, and design specifications.",
  },
  {
    question: "Do you only work with custom code, or do you also support page builders like Elementor or WPBakery?",
    answer: "I work with the stack that best fits the project. If you have an existing site on a page builder, I can audit, optimize, and fix issues without forcing a ground-up rebuild. For new projects, we evaluate the best direction (native FSE/blocks, custom ACF build, or a builder if required).",
  },
  {
    question: "How do we get started?",
    answer: "You can request a quick call or send a message via the contact section. In a short conversation, we review your current setup and determine the best action plan.",
  },
  {
    question: "How is your technical maintenance different from standard options?",
    answer: "I don't just hit \"update\" on a live site. Updates are tested in a Staging environment first, backed by automated backups and active monitoring to ensure continuous uptime.",
  },
  {
    question: "What is included in a Technical Audit?",
    answer: "You get a clear report diagnosing your site's current state: real-world speed analysis, database queries, plugin/theme risk assessment, and a prioritized action roadmap.",
  },
  {
    question: "Will I fully own the code and project assets?",
    answer: "Yes, 100%. All developed code, repositories, configurations, and access credentials belong to you or your agency, complete with documentation for full autonomy.",
  },
];
// Blog Links
export const blog_links = [
  {
    title: "WordPress Maintenance: The Invisible Work Behind a Live Site",
    link: "https://juanfalibene.com/writing/#/post/id=1975&category=idea-de-proyecto",
  },
  {
    title: "Discava! 2.0 - A Vinyl Search App with API integration",
    link: "https://juanfalibene.com/writing/#/post/id=1943&category=idea-de-proyecto",
  },
  {
    title: "Developing a Wordpress Bot for Content Creation",
    link: "https://juanfalibene.com/writing/#/post/id=1923&category=idea-de-proyecto",
  },
  {
    title: "Update a personal project with Antigravity",
    link: "https://juanfalibene.com/writing/#/post/id=1890&category=nota",
  },
  {
    title: "Vibe Coding Test with Lovable App: Calitrack",
    link: "https://juanfalibene.com/writing/#/post/id=1909&category=idea-de-proyecto",
  },
  {
    title: "2025 Web Resume",
    link: "https://juanfalibene.com/writing/#/post/id=1824&category=historia",
  },
  {
    title: "Wireframes: from idea to fully implemented design",
    link: "https://juanfalibene.com/writing/#/post/id=1369&category=trabajo-cotidiano",
  },
  /*{
    title: "Windsurf AI autocomplete",
    link: "https://juanfalibene.com/writing/#/post/id=837&category=nota",
  },*/
  /*{
    title: "Exploring Python & Automation",
    link: "https://juanfalibene.com/writing/#/post/id=776&category=reflexion",
  },*/
  {
    title: "Testing GPT o3-mini-high",
    link: "https://juanfalibene.com/writing/#/post/id=756&category=nota",
  },
  {
    title: "Everyday Matters: ChatGPT Project",
    link: "https://juanfalibene.com/writing/#/post/id=752&category=idea-de-proyecto",
  },
  {
    title: "WP Headless Introduction",
    link: "https://juanfalibene.com/writing/#/post/id=28&category=idea-de-proyecto",
  },
  /*{
    title: "WP Theme Development from Scratch",
    link: "https://juanfalibene.com/writing/#/post/id=655&category=idea-de-proyecto",
  },
  {
    title: "Web Resume 2024",
    link: "https://juanfalibene.com/writing/#/post/id=737&category=reflexion",
  },
  {
    title: "My Online Journey",
    link: "https://juanfalibene.com/writing/#/post/id=522&category=historia",
  },*/
];
// About Links
export const about_links = [
  {
    name: "Linkedin",
    link: "https://www.linkedin.com/in/juanfalibene/",
    category: "professional",
  },
  {
    name: "GitHub",
    link: "https://github.com/juanfalibene",
    category: "professional",
  },
  /*{
    name: "Behance",
    link: "https://www.behance.net/juanfalibene",
    category: "professional",
  },*/
  {
    name: "Blog",
    link: "https://juanfalibene.com/writing/",
    category: "personal",
  },
  {
    name: "Music",
    link: "https://music.juanfalibene.com",
    category: "personal",
  },
  {
    name: "Dev & UX/UI Resources",
    link: "https://links.juanfalibene.com/dev-tree",
    category: "development",
  },
  {
    name: "Discava! (Discogs API)",
    link: "http://dev.juanfalibene.com/discava/index.html",
    category: "development",
  },
  {
    name: "©Juan Falibene 2026",
    category: "credit",
  },
  {
    name: "Barcelona",
    category: "credit",
  },
];
// Certificates
export const certificates = [
  {
    name: "Desenvolupament web Front End CIFO L'Hospitalet",
    link: "https://juanfalibene.com/resume/downloads/Certificat-417219-Y8901768T.PDF",
    year: 2023,
  },
  {
    name: "SEO, SEM i analítica Web",
    link: "https://juanfalibene.com/resume/downloads/16_ca355c68-8cdf-4f34-b3a4-8c8c0aadb87b_f2150287-6a9e-44e7-afd7-3ecc90493f73.pdf",
    year: 2025,
  },
  {
    name: "Backend & Automation: Python, Flask, Django",
    link: "https://juanfalibene.com/resume/downloads/diploma.pdf",
    year: 2025,
  },
  {
    name: "English Reading(C2) & Listening(B2) EF SET",
    link: "https://juanfalibene.com/resume/downloads/EF_SET_Certificate.pdf",
    year: 2024,
  },
  {
    name: "CSS: Diseño web responsive",
    link: "https://juanfalibene.com/resume/downloads/1673896108444.png",
    year: 2023,
  },
  {
    name: "Diseño de interfaz (UI)",
    link: "https://juanfalibene.com/resume/downloads/1673478097062.png",
    year: 2023,
  },
  {
    name: "Experiencia de usuario (UX)",
    link: "https://juanfalibene.com/resume/downloads/1673444494312.png",
    year: 2023,
  },
];
// Resume
export const resume_urls = [
  {
    name: "Resume ESP PDF",
    link: "https://juanfalibene.com/resume/downloads/Juan_Ignacio_Falibene_CV_2026.pdf",
    action: "Download",
  },
  {
    name: "Resume ENG PDF",
    link: "https://juanfalibene.com/resume/downloads/Juan_Ignacio_Falibene_CV_EN_2026.pdf",
    action: "Download",
  },
  {
    name: "Resume Online",
    link: "https://juanfalibene.com/resume/index.html",
    action: "View",
  },
];
